import { getCsrfToken } from "design_system/utils/cookie";
import { createFormData } from "./fetch";

export const EVENTS_ENDPOINT = "/events/record";

type Event = {
    target?: string;
    type: string;
    page?: string;
    details?: Record<string, any>;
    extraBodyContent?: Record<string, any>;
};

export async function logEngagementEvent({
    target,
    type,
    page,
    details,
    extraBodyContent = {},
}: Event) {
    try {
        const urlParams = new URLSearchParams(window?.location?.search);
        const user = urlParams.get("user");
        const link = urlParams.get("link");

        const bodyContent: Record<string, string> = {
            csrfmiddlewaretoken: getCsrfToken(),
            event_type: type,
            current_page: page ?? window?.location?.pathname,
            ...(target && { event_target: target }),
            ...(details && { event_details: JSON.stringify(details) }),
            ...(user && { user }),
            ...(link && { link }),
            ...extraBodyContent,
        };

        if (bodyContent.user && !bodyContent.user_public_id) {
            bodyContent.user_public_id = bodyContent.user;
        }

        if (navigator.sendBeacon) {
            const filteredData = Object.keys(bodyContent).reduce((acc, key) => {
                if (bodyContent[key] !== null && bodyContent[key] !== undefined) {
                    acc[key] = bodyContent[key];
                }
                return acc;
            }, {} as Record<string, string>);
            const blob = new Blob([new URLSearchParams(filteredData).toString()], {
                type: "application/x-www-form-urlencoded",
            });
            navigator.sendBeacon(EVENTS_ENDPOINT, blob);
        } else {
            const body = createFormData(bodyContent);

            const res = await fetch(EVENTS_ENDPOINT, {
                method: "POST",
                body,
            });
            if (!res.ok) {
                throw new Error(res.statusText);
            }
        }
    } catch (error) {
        // https://cedar-jira.atlassian.net/browse/CED-65205
        console.warn("Failed to record engagement event.", error);
    }
}
